import WikipediaSourceIcon from "../../assets/components/sources/WikipediaSourceIcon";

const WikipediaLogomark = ({ height }: { height: number }) => {
  return <WikipediaSourceIcon height={height} />;
};

export default WikipediaLogomark;
